if (!window.theme.isDevTheme) {
  // eslint-disable-next-line no-undef,camelcase
  __webpack_public_path__ = window.__webpack_public_path__;
}